import { LOAD } from "../actions/companyProfile.actions";

const INITIAL_STATE = {};

export default function(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case LOAD:
      return { ...state, data: action.data };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/companyProfile.reducer.js